<mat-card style="border-color: #5775a8;">

  <mat-card-header>
    <div class="flex flex-row rounded-lg w-full" style="background-color: #5775a8;align-items: center;">
      <div class="flex w-full" style="padding: 15px;">
        <span style="color: white;">
          All Associated Complaints
        </span>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <br />
    <mat-card>
      <div class="flex flex-col" style="overflow-x:auto">
        <div class="flex flex-row">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
            class="mat-elevation-z8">

            <ng-container matColumnDef="complaintId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
              <td mat-cell *matCellDef="let comments" style="align-items: center; text-align: center;">
                <a (click)="gotoComplaint(comments.complaintId)">{{comments.complaintId}}</a>
              </td>
            </ng-container>
            <ng-container matColumnDef="complaintDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Date</th>
              <td mat-cell *matCellDef="let comments">{{comments.complaintDate}}</td>
            </ng-container>
            <ng-container matColumnDef="complaintStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Status</th>
              <td mat-cell *matCellDef="let comments">{{comments.complaintStatus}}</td>
            </ng-container>
            <ng-container matColumnDef="actionable">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Actionable</th>
              <td mat-cell *matCellDef="let comments">
                <span *ngIf="comments.actionable" style="color:red;">Yes</span>
                <span *ngIf="!comments.actionable" style="color:green;">No</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="complaintComments">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Text</th>
              <td mat-cell *matCellDef="let comments">{{comments.complaintComments}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
          </table>

        </div>
      </div>
    </mat-card>
    <br />

  </mat-card-content>

</mat-card>